import Reveal from "@/components/feature/Reveal";
import SectionHeading from "@/components/feature/SectionHeading";
import { recruitRequirements, recruitPersona } from "@/mocks/legalPages";

/** 採用ページ REQUIREMENTS（募集要項）＋ 求める人物像。カード化せず罫線テーブルで構成する。 */
export default function RecruitRequirements() {
  return (
    <section className="bg-background-100 py-20 md:py-28 lg:py-32">
      <div className="u-container">
        <div className="mx-auto max-w-3xl">
          <Reveal>
            <SectionHeading en={recruitRequirements.en} jp={recruitRequirements.heading} />
          </Reveal>

          <Reveal delay={100}>
            <dl className="mt-10 border-t border-foreground-950/12 md:mt-14">
              {recruitRequirements.rows.map((row) => (
                <div
                  key={row.label}
                  className="grid grid-cols-1 gap-2.5 border-b border-foreground-950/12 py-6 sm:grid-cols-[200px_1fr] sm:gap-8"
                >
                  <dt className="text-[13px] text-foreground-600">{row.label}</dt>
                  <dd className="font-heading text-[15px] leading-[1.9] text-foreground-950 whitespace-pre-line md:text-base">
                    {row.value}
                  </dd>
                </div>
              ))}
            </dl>
          </Reveal>

          <Reveal delay={140}>
            <div className="mt-16 md:mt-20">
              <h3 className="font-heading text-[20px] leading-[1.6] text-foreground-950 md:text-[24px]">
                {recruitPersona.heading}
              </h3>
              <ul className="mt-7 space-y-3.5">
                {recruitPersona.items.map((item) => (
                  <li
                    key={item}
                    className="flex items-start gap-3.5 text-[13px] leading-[2] text-foreground-700 md:text-sm"
                  >
                    <i className="ri-checkbox-blank-circle-line mt-[7px] text-[8px] text-accent-600" aria-hidden />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}